import {MainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuView';
import {IRecodeVAPI} from '@fantasmagames/slot/src/integration/RecodeIntegrator';
import {MainMenuViewEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuViewEvents';

export class RecodeMainMenuView extends MainMenuView {
	public init(): void {
		super.init();
		if (this.destroyLobbyButtonCheck()) {
			this.destroyLobbyButton();
		}
	}

	public openLobbyLink(): void {
		const vApi: IRecodeVAPI = (window as any).V.API;
		vApi.Core.launchLobby();
		this.emit(MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN);
	}

	protected destroyLobbyButton(): void {
		this._lobbyButton.destroy();
	}

	protected destroyLobbyButtonCheck(): boolean {
		return !(window as any).V.API.Core.isLobbyAvailable();
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/recode/RecodeMainMenuView.ts